/* eslint-disable max-len */
/* eslint-disable react/jsx-props-no-spreading */
import React, { Suspense } from 'react';

const ProductDetailsAccordion = React.lazy(() => import('./ProductDetailsAccordion'));

export const ProductDetailsAccordionSuspense = (props) => {
  if (typeof window === 'undefined') return <div />;

  return (
    <Suspense fallback={<div />}>
      <ProductDetailsAccordion {...props} />
    </Suspense>
  );
};
